export enum CAR_DETAILS_STORAGE_KEYS {
  TyreLabelPrintSizePreference = "car-details-tyre-label-print-size-preference"
}
